/** @fileoverview Empty state shown when the matrix has no data to render. */

import { Box, Stack, Text } from '@mantine/core'
import { IconArticleOff } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'

type Variant = 'select_class' | 'select_project' | 'no_tasks' | 'no_students'

interface TaskTrackerEmptyStateProps {
  variant: Variant
}

const KEYS: Record<Variant, { title: string; text: string }> = {
  select_class: {
    title: 'task_tracker.empty.select_class_title',
    text: 'task_tracker.empty.select_class_description',
  },
  select_project: {
    title: 'task_tracker.empty.select_project_title',
    text: 'task_tracker.empty.select_project_description',
  },
  no_tasks: {
    title: 'task_tracker.empty.no_tasks_title',
    text: 'task_tracker.empty.no_tasks_description',
  },
  no_students: {
    title: 'task_tracker.empty.no_students_title',
    text: 'task_tracker.empty.no_students_description',
  },
}

const CONTAINER_STYLE = {
  border: '1px dashed var(--mantine-color-gray-5, #adb5bd)',
  borderRadius: 12,
  backgroundColor: 'var(--mantine-color-gray-1, #f8f9fa)',
}

export function TaskTrackerEmptyState({ variant }: TaskTrackerEmptyStateProps) {
  const { t } = useTranslation()
  const { title, text } = KEYS[variant]

  return (
    <Box p="xl" style={CONTAINER_STYLE}>
      <Stack align="center" spacing={8}>
        <IconArticleOff size={24} color="#868e96" stroke={1.8} />
        <Text weight={600} align="center" size="md">{t(title)}</Text>
        <Text color="dimmed" align="center" size="md">{t(text)}</Text>
      </Stack>
    </Box>
  )
}
